// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:1023.98px){.layout--campaign .header__container{grid-template-columns:min-content auto min-content!important}}.layout--campaign .header__footer{grid-gap:0!important}@media(max-width:380px){.layout:not(.layout--campaign) .header__container{grid-gap:8px}.layout:not(.layout--campaign) .header__footer .v-button{--btn-height:30px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
